import React from 'react';

import { Skeleton } from '@atlaskit/avatar';

const AvatarSkeletonCircleExample = (): React.JSX.Element => {
	return <Skeleton appearance="circle" />;
};

export default AvatarSkeletonCircleExample;
